import * as React from 'react';

import {colors} from '../../colors/colors';

import styles from './column-header.module.css';

export type Direction = 'left' | 'right';

type Props = {
    text: string;
    icon: React.ComponentType<any> | null | undefined;
};

export function ColumnHeader(props: Props) {
    const {text, icon: IconComponent} = props;
    const Icon = IconComponent || null;

    return (
        <div className={styles['column-header']}>
            {Icon ? (
                <div className={styles.icon}>
                    <Icon wrapWithDiv={false} fill={colors.grey} size={13} />
                </div>
            ) : null}
            <span>{text}</span>
        </div>
    );
}
